<template>
  
  <form
    v-loading="loading"
    @submit.prevent="$marketplacesCategory_save"
  >
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label>{{ $t('Name') }}</label>
          <b-form-input
            v-model="model.name"
            :required="true"
            type="text"
            name="name"
            minlength="3"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>{{ $t('Marketplace') }} UID</label>
          <b-form-input
            v-model="model.marketplaceUid"
            :required="true"
            type="text"
            name="marketplaceUid"
            minlength="3"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label>{{ $t('Marketplace') }}</label>
          <app-marketplace-dropdown v-model="model.marketplace" @select-marketplace="selectMarketplace" />
        </div>
        <div class="form-check">
          <input
            id="marketplace-category-is-listing-allowed"
            v-model="model.isListingAllowed"
            class="form-check-input"
            type="checkbox"
          >
          <label
            class="form-check-label"
            for="marketplace-category-is-listing-allowed"
          >
            {{ $t('Is allowed for listings') }}
          </label>
        </div>
      </div>
    </div>
    <button
      type="submit"
      class="btn btn-primary"
    >
      {{ $t('Save') }}
    </button>
  </form>
</template>

<script>
import AppMarketplaceDropdown from '../components/marketplaces/MarketplaceDropDown.vue';
import MarketplacesCategoryMixins from '../mixins/MarketplacesCategoryMixins';

export default {
  name: 'AppPageMarketplacesCategory',
  components: {
    AppMarketplaceDropdown,
  },
  mixins: [
    MarketplacesCategoryMixins,
  ],
  methods:{
    selectMarketplace(val){
      this.model.marketplace = val;
    }
  },
  watch: {
    '$route.params.categoryId': {
      immediate: true,
      handler(categoryId) {
        this.$marketplacesCategory_load(categoryId);
      },
    },
  },
};
</script>
